import React from 'react';
import { Box, EmptyServicesListIcon } from '@common-fe/common-fe';

import PlaceholderBaseDefault, { Props as PlaceholderBaseDefaultProps } from './PlaceholderBaseDefault';
import PlaceholderBaseLink, { Props as PlaceholderBaseLinkProps } from './PlaceholderBaseLink';
import PlaceholderBaseSearching, { Props as PlaceholderBaseSearchingProps } from './PlaceholderBaseSearching';

interface NodeProps {
  Link: React.FC<PlaceholderBaseLinkProps>;
  Search: React.FC<PlaceholderBaseSearchingProps>;
  Default: React.FC<PlaceholderBaseDefaultProps>;
}

interface Props {
  children: React.ReactNode;
  isLarge?: boolean;
  testId?: string;
}
const PlaceholderBase: React.FC<Props> & NodeProps = ({ testId = 'placeholder-base', children, isLarge }) => {
  return (
    <Box
      data-testid={testId}
      align="center"
      justify="center"
      round="container1Round"
      border={{ size: 'small', color: 'border1' }}
      background="canvas"
      pad="spacing24"
      height={{ min: isLarge ? 'calc(100vh - 550px)' : 'calc(100vh - 550px)' }}
    >
      <Box align="center" justify="center" pad="spacing18">
        <Box margin={{ top: 'spacing16' }}>
          <EmptyServicesListIcon size="69px" color="iconSecondary" />
        </Box>

        <Box margin={{ top: 'spacing24' }}>{children}</Box>
      </Box>
    </Box>
  );
};

PlaceholderBase.Search = PlaceholderBaseSearching;
PlaceholderBase.Default = PlaceholderBaseDefault;
PlaceholderBase.Link = PlaceholderBaseLink;
export default PlaceholderBase;
